var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnstar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.546,
    height: 17.546,
    viewBox: "0 0 17.546 17.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16086",
    "data-name": "Group 16086",
    transform: "translate(-1191.439 -499.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "starred",
    transform: "translate(1192 501.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13790",
    "data-name": "Path 13790",
    d: "M14.536,16.963a1.4,1.4,0,0,0-.725-.334L10.5,16.148l-1.482-3a1.4,1.4,0,0,0-2.517,0l-1.482,3L1.7,16.63a1.4,1.4,0,0,0-.778,2.394l2.4,2.337-.566,3.3a1.4,1.4,0,0,0,2.037,1.48l2.964-1.558,2.964,1.558a1.4,1.4,0,0,0,2.037-1.48l-.566-3.3,2.4-2.337a1.405,1.405,0,0,0-.053-2.06Zm-.669,1.32-2.648,2.581a.369.369,0,0,0-.106.327l.625,3.645a.368.368,0,0,1-.536.389L7.929,23.5a.369.369,0,0,0-.344,0L4.312,25.225a.368.368,0,0,1-.536-.389L4.4,21.191a.369.369,0,0,0-.106-.327L1.647,18.283a.369.369,0,0,1,.2-.63l3.66-.532a.369.369,0,0,0,.278-.2L7.425,13.6a.369.369,0,0,1,.662,0l1.637,3.316a.369.369,0,0,0,.278.2l3.66.532a.369.369,0,0,1,.2.635Z",
    transform: "translate(-0.488 -12.351)",
    fill: "#6a92c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13791",
    "data-name": "Path 13791",
    d: "M10.885,25.83a1.421,1.421,0,0,1-.659-.163L7.268,24.111,4.31,25.667a1.415,1.415,0,0,1-2.054-1.492l.565-3.294L.428,18.547a1.415,1.415,0,0,1,.785-2.415l3.307-.481,1.479-3a1.415,1.415,0,0,1,2.539,0l1.479,3,3.307.481a1.415,1.415,0,0,1,.785,2.415L11.716,20.88l.565,3.294a1.416,1.416,0,0,1-1.4,1.656ZM7.268,24.084h.006l2.964,1.558a1.391,1.391,0,0,0,2.019-1.467l-.567-3.306,2.4-2.342a1.391,1.391,0,0,0-.771-2.374L10,15.674v-.006l-1.482-3a1.391,1.391,0,0,0-2.5,0L4.536,15.674H4.529l-3.314.481a1.391,1.391,0,0,0-.77,2.375l2.4,2.342v.006l-.566,3.3A1.391,1.391,0,0,0,4.3,25.645Zm3.617.712a.378.378,0,0,1-.178-.045L7.435,23.03a.363.363,0,0,0-.333,0L3.829,24.751a.378.378,0,0,1-.178.045.383.383,0,0,1-.293-.138.374.374,0,0,1-.083-.309L3.9,20.7a.357.357,0,0,0-.1-.316L1.15,17.807a.381.381,0,0,1,.211-.651l3.66-.532a.357.357,0,0,0,.269-.2l1.637-3.316a.381.381,0,0,1,.684,0l1.637,3.316a.357.357,0,0,0,.269.2l3.66.532a.381.381,0,0,1,.211.651L10.74,20.388a.357.357,0,0,0-.1.316l.625,3.645a.374.374,0,0,1-.083.309.383.383,0,0,1-.3.142ZM7.268,22.965a.383.383,0,0,1,.178.044l3.273,1.721a.355.355,0,0,0,.166.042.359.359,0,0,0,.275-.129.35.35,0,0,0,.078-.289l-.625-3.645a.381.381,0,0,1,.11-.338l2.648-2.581a.357.357,0,0,0-.2-.609l-3.66-.532a.381.381,0,0,1-.287-.209L7.589,13.124a.357.357,0,0,0-.641,0L5.311,16.44a.381.381,0,0,1-.287.209l-3.66.532a.357.357,0,0,0-.2.609l2.648,2.581a.381.381,0,0,1,.11.338L3.3,24.353a.35.35,0,0,0,.078.289.359.359,0,0,0,.275.129.355.355,0,0,0,.166-.042l3.273-1.721a.383.383,0,0,1,.176-.043Z",
    transform: "translate(0 -11.866)",
    fill: "#6a92c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16085",
    "data-name": "Group 16085"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    x2: 15,
    y2: 15,
    transform: "translate(1192.712 500.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305",
    "data-name": "Line 305",
    x2: 15,
    y2: 15,
    transform: "translate(1192.5 501.044)",
    fill: "none",
    stroke: "#6a92c5",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstar);
export default __webpack_public_path__ + "static/media/unstar.c62369c3.svg";
export { ForwardRef as ReactComponent };